"use strict";
//
// Copyright © 2024 Hardcore Engineering Inc
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = exports.providers = void 0;
const platform_1 = require("@hcengineering/platform");
exports.providers = [];
exports.Analytics = {
    data: {},
    init(provider, config) {
        const res = provider.init(config);
        if (res) {
            exports.providers.push(provider);
        }
    },
    setUser(email, data) {
        exports.providers.forEach((provider) => {
            provider.setUser(email, data);
        });
    },
    setAlias(distinctId, alias) {
        exports.providers.forEach((provider) => {
            provider.setAlias(distinctId, alias);
        });
    },
    setTag(key, value) {
        exports.providers.forEach((provider) => {
            provider.setTag(key, value);
        });
    },
    setWorkspace(ws, guest) {
        exports.providers.forEach((provider) => {
            provider.setWorkspace(ws, guest);
        });
    },
    handleEvent(event, params = {}) {
        exports.providers.forEach((provider) => {
            provider.handleEvent(event, { ...this.data, ...params });
        });
    },
    handleError(error) {
        exports.providers.forEach((provider) => {
            provider.handleError(error);
        });
    },
    handleMetric(name, value, labels) {
        exports.providers.forEach((provider) => {
            provider.handleMetric?.(name, value, labels);
        });
    },
    async flush() {
        await Promise.all(exports.providers.map(async (provider) => {
            await provider.flush?.();
        }));
    },
    navigate(path) {
        exports.providers.forEach((provider) => {
            provider.navigate(path);
        });
    },
    logout() {
        exports.providers.forEach((provider) => {
            provider.logout();
        });
    }
};
(0, platform_1.addEventListener)(platform_1.PlatformEvent, async (_event, _status) => {
    if (_status.severity === platform_1.Severity.ERROR) {
        // Skip error broadcast in translate to avoid infinite loop
        const label = await (0, platform_1.translate)(_status.code, _status.params, 'en', true);
        exports.Analytics.handleError(new Error(label));
    }
});
//# sourceMappingURL=index.js.map